//------------------------------------------------------------
// File:      Schools.ts
// Author:    Tony Henderson
// Generator: ElevenFiftyNine Automated Tool Chain  
// Project:   https://github.com/BinaryBlox-Schedule-API
//------------------------------------------------------------


// Entity Side Effects: Schools Entity Effects  
import { ThunkAction, Action  } from '@reduxjs/toolkit'
import { entityActions } from '../slices/Schools.slice'
import { ApiManager } from '../../api-manager';

const DEFAULT_TARGET: string = '/'; 

/**
* Generated import statments Schools for tag entities 
*/
import { 
    SchoolRequest, 
    SchoolCohortRequest, 
    SchoolDesignatedContactRequest, 
    SchoolInformationRequest, 
} from '../../model/index';




/**
* apiSchoolsGetPOST
* @param apiFactory PostApiSchoolGetSchoolBySchoolCodeApiFactory
* @param body SchoolRequest
* @param history any  (optional) 
* @param target string (optional)
*/
export const fetchGet_School_GetSchoolBySchoolCode = <R>(apiFactory: Function, body: SchoolRequest, history?: any, target?: string, debug?: boolean, mock?: any): ThunkAction<any, R, null, Action<string>> => async (dispatch: (request: any, history?: any, target?: string) => any) => {

      if(!apiFactory){ 
            console.log(`API Factory is undefined or null :  SchoolApiFactory `);
            return; 
      };

      const apiCall: string =  'apiSchoolGetPost';    
      const entityApi =   apiFactory(ApiManager.getInstance().getConfiguration()); 
      console.log(`API: ${apiCall}`); 

      let payload = body; 
      if(debug){console.log(`PAYLOAD: ${JSON.stringify(payload, undefined, '\t')}`)};

      dispatch(entityActions.get_School_GetSchoolBySchoolCode_Data())

      // Mock implementation to be tested 
      if(mock){
            console.log(`MOCK API SUCCESS: ${apiCall}`);       
            return await dispatch(entityActions.get_School_GetSchoolBySchoolCode_Data_Success(mock))
      }

      return await entityApi.apiSchoolGetSchoolBySchoolCodePost("1.0.0", payload).then((response: any) => {        
            console.log(`API SUCCESS: ${apiCall}`);      
            const result = response; 
            return dispatch(entityActions.get_School_GetSchoolBySchoolCode_Data_Success(result.data))
            },
            (error: { data: any; }) => {
                  console.log(`API FAIL: ${apiCall}`);
                  return dispatch(entityActions.get_School_GetSchoolBySchoolCode_Data_Fault(error.data))
      }); 
}

/**
* apiSchoolsGetPOST
* @param apiFactory PostApiSchoolGetSchoolsByUserEmailApiFactory
* @param body SchoolRequest
* @param history any  (optional) 
* @param target string (optional)
*/
export const fetchGet_School_GetSchoolsByUserEmail = <R>(apiFactory: Function, body: SchoolRequest, history?: any, target?: string, debug?: boolean, mock?: any): ThunkAction<any, R, null, Action<string>> => async (dispatch: (request: any, history?: any, target?: string) => any) => {

      if(!apiFactory){ 
            console.log(`API Factory is undefined or null :  SchoolApiFactory `);
            return; 
      };

      const apiCall: string =  'apiSchoolGetPost';    
      const entityApi =   apiFactory(ApiManager.getInstance().getConfiguration()); 
      console.log(`API: ${apiCall}`); 

      let payload = body; 
      if(debug){console.log(`PAYLOAD: ${JSON.stringify(payload, undefined, '\t')}`)};

      dispatch(entityActions.get_School_GetSchoolsByUserEmail_Data())

      // Mock implementation to be tested 
      if(mock){
            console.log(`MOCK API SUCCESS: ${apiCall}`);       
            return await dispatch(entityActions.get_School_GetSchoolsByUserEmail_Data_Success(mock))
      }

      return await entityApi.apiSchoolGetSchoolsByUserEmailPost("1.0.0", payload).then((response: any) => {        
            console.log(`API SUCCESS: ${apiCall}`);      
            const result = response; 
            return dispatch(entityActions.get_School_GetSchoolsByUserEmail_Data_Success(result.data))
            },
            (error: { data: any; }) => {
                  console.log(`API FAIL: ${apiCall}`);
                  return dispatch(entityActions.get_School_GetSchoolsByUserEmail_Data_Fault(error.data))
      }); 
}

/**
* apiSchoolsUpdatePOST
* @param apiFactory PostApiSchoolUpdateApiFactory
* @param body SchoolRequest
* @param history any  (optional) 
* @param target string (optional)
*/
export const fetchUpdate_School_Update = <R>(apiFactory: Function, body: SchoolRequest, history?: any, target?: string, debug?: boolean, mock?: any): ThunkAction<any, R, null, Action<string>> => async (dispatch: (request: any, history?: any, target?: string) => any) => {

      if(!apiFactory){ 
            console.log(`API Factory is undefined or null :  SchoolApiFactory `);
            return; 
      };

      const apiCall: string =  'apiSchoolUpdatePost';    
      const entityApi =   apiFactory(ApiManager.getInstance().getConfiguration()); 
      console.log(`API: ${apiCall}`); 

      let payload = body; 
      if(debug){console.log(`PAYLOAD: ${JSON.stringify(payload, undefined, '\t')}`)};

      dispatch(entityActions.update_School_Update_Data())

      // Mock implementation to be tested 
      if(mock){
            console.log(`MOCK API SUCCESS: ${apiCall}`);       
            return await dispatch(entityActions.update_School_Update_Data_Success(mock))
      }

      return await entityApi.apiSchoolUpdatePost("1.0.0", payload).then((response: any) => {        
            console.log(`API SUCCESS: ${apiCall}`);      
            const result = response; 
            return dispatch(entityActions.update_School_Update_Data_Success(result.data))
            },
            (error: { data: any; }) => {
                  console.log(`API FAIL: ${apiCall}`);
                  return dispatch(entityActions.update_School_Update_Data_Fault(error.data))
      }); 
}

/**
* apiSchoolsGetPOST
* @param apiFactory PostApiSchoolCohortGetSchoolCohortsBySchoolCodeApiFactory
* @param body SchoolCohortRequest
* @param history any  (optional) 
* @param target string (optional)
*/
export const fetchGet_SchoolCohort_GetSchoolCohortsBySchoolCode = <R>(apiFactory: Function, body: SchoolCohortRequest, history?: any, target?: string, debug?: boolean, mock?: any): ThunkAction<any, R, null, Action<string>> => async (dispatch: (request: any, history?: any, target?: string) => any) => {

      if(!apiFactory){ 
            console.log(`API Factory is undefined or null :  SchoolCohortApiFactory `);
            return; 
      };

      const apiCall: string =  'apiSchoolCohortGetPost';    
      const entityApi =   apiFactory(ApiManager.getInstance().getConfiguration()); 
      console.log(`API: ${apiCall}`); 

      let payload = body; 
      if(debug){console.log(`PAYLOAD: ${JSON.stringify(payload, undefined, '\t')}`)};

      dispatch(entityActions.get_SchoolCohort_GetSchoolCohortsBySchoolCode_Data())

      // Mock implementation to be tested 
      if(mock){
            console.log(`MOCK API SUCCESS: ${apiCall}`);       
            return await dispatch(entityActions.get_SchoolCohort_GetSchoolCohortsBySchoolCode_Data_Success(mock))
      }

      return await entityApi.apiSchoolCohortGetSchoolCohortsBySchoolCodePost("1.0.0", payload).then((response: any) => {        
            console.log(`API SUCCESS: ${apiCall}`);      
            const result = response; 
            return dispatch(entityActions.get_SchoolCohort_GetSchoolCohortsBySchoolCode_Data_Success(result.data))
            },
            (error: { data: any; }) => {
                  console.log(`API FAIL: ${apiCall}`);
                  return dispatch(entityActions.get_SchoolCohort_GetSchoolCohortsBySchoolCode_Data_Fault(error.data))
      }); 
}

/**
* apiSchoolsCreatePOST
* @param apiFactory PostApiSchoolDesignatedContactCreateApiFactory
* @param body SchoolDesignatedContactRequest
* @param history any  (optional) 
* @param target string (optional)
*/
export const fetchCreate_SchoolDesignatedContact_Create = <R>(apiFactory: Function, body: SchoolDesignatedContactRequest, history?: any, target?: string, debug?: boolean, mock?: any): ThunkAction<any, R, null, Action<string>> => async (dispatch: (request: any, history?: any, target?: string) => any) => {

      if(!apiFactory){ 
            console.log(`API Factory is undefined or null :  SchoolDesignatedContactApiFactory `);
            return; 
      };

      const apiCall: string =  'apiSchoolDesignatedContactCreatePost';    
      const entityApi =   apiFactory(ApiManager.getInstance().getConfiguration()); 
      console.log(`API: ${apiCall}`); 

      let payload = body; 
      if(debug){console.log(`PAYLOAD: ${JSON.stringify(payload, undefined, '\t')}`)};

      dispatch(entityActions.create_SchoolDesignatedContact_Create_Data())

      // Mock implementation to be tested 
      if(mock){
            console.log(`MOCK API SUCCESS: ${apiCall}`);       
            return await dispatch(entityActions.create_SchoolDesignatedContact_Create_Data_Success(mock))
      }

      return await entityApi.apiSchoolDesignatedContactCreatePost("1.0.0", payload).then((response: any) => {        
            console.log(`API SUCCESS: ${apiCall}`);      
            const result = response; 
            return dispatch(entityActions.create_SchoolDesignatedContact_Create_Data_Success(result.data))
            },
            (error: { data: any; }) => {
                  console.log(`API FAIL: ${apiCall}`);
                  return dispatch(entityActions.create_SchoolDesignatedContact_Create_Data_Fault(error.data))
      }); 
}

/**
* apiSchoolsDeletePOST
* @param apiFactory PostApiSchoolDesignatedContactDeleteApiFactory
* @param body SchoolDesignatedContactRequest
* @param history any  (optional) 
* @param target string (optional)
*/
export const fetchDelete_SchoolDesignatedContact_Delete = <R>(apiFactory: Function, body: SchoolDesignatedContactRequest, history?: any, target?: string, debug?: boolean, mock?: any): ThunkAction<any, R, null, Action<string>> => async (dispatch: (request: any, history?: any, target?: string) => any) => {

      if(!apiFactory){ 
            console.log(`API Factory is undefined or null :  SchoolDesignatedContactApiFactory `);
            return; 
      };

      const apiCall: string =  'apiSchoolDesignatedContactDeletePost';    
      const entityApi =   apiFactory(ApiManager.getInstance().getConfiguration()); 
      console.log(`API: ${apiCall}`); 

      let payload = body; 
      if(debug){console.log(`PAYLOAD: ${JSON.stringify(payload, undefined, '\t')}`)};

      dispatch(entityActions.delete_SchoolDesignatedContact_Delete_Data())

      // Mock implementation to be tested 
      if(mock){
            console.log(`MOCK API SUCCESS: ${apiCall}`);       
            return await dispatch(entityActions.delete_SchoolDesignatedContact_Delete_Data_Success(mock))
      }

      return await entityApi.apiSchoolDesignatedContactDeletePost("1.0.0", payload).then((response: any) => {        
            console.log(`API SUCCESS: ${apiCall}`);      
            const result = response; 
            return dispatch(entityActions.delete_SchoolDesignatedContact_Delete_Data_Success(result.data))
            },
            (error: { data: any; }) => {
                  console.log(`API FAIL: ${apiCall}`);
                  return dispatch(entityActions.delete_SchoolDesignatedContact_Delete_Data_Fault(error.data))
      }); 
}

/**
* apiSchoolsGetAllPOST
* @param apiFactory PostApiSchoolDesignatedContactGetSchoolDesignatedContactBySchoolCodeApiFactory
* @param body SchoolDesignatedContactRequest
* @param history any  (optional) 
* @param target string (optional)
*/
export const fetchGetAll_SchoolDesignatedContact_GetSchoolDesignatedContactBySchoolCode = <R>(apiFactory: Function, body: SchoolDesignatedContactRequest, history?: any, target?: string, debug?: boolean, mock?: any): ThunkAction<any, R, null, Action<string>> => async (dispatch: (request: any, history?: any, target?: string) => any) => {

      if(!apiFactory){ 
            console.log(`API Factory is undefined or null :  SchoolDesignatedContactApiFactory `);
            return; 
      };

      const apiCall: string =  'apiSchoolDesignatedContactGetAllPost';    
      const entityApi =   apiFactory(ApiManager.getInstance().getConfiguration()); 
      console.log(`API: ${apiCall}`); 

      let payload = body; 
      if(debug){console.log(`PAYLOAD: ${JSON.stringify(payload, undefined, '\t')}`)};

      dispatch(entityActions.getAll_SchoolDesignatedContact_GetSchoolDesignatedContactBySchoolCode_Data())

      // Mock implementation to be tested 
      if(mock){
            console.log(`MOCK API SUCCESS: ${apiCall}`);       
            return await dispatch(entityActions.getAll_SchoolDesignatedContact_GetSchoolDesignatedContactBySchoolCode_Data_Success(mock))
      }

      return await entityApi.apiSchoolDesignatedContactGetSchoolDesignatedContactBySchoolCodePost("1.0.0", payload).then((response: any) => {        
            console.log(`API SUCCESS: ${apiCall}`);      
            const result = response; 
            return dispatch(entityActions.getAll_SchoolDesignatedContact_GetSchoolDesignatedContactBySchoolCode_Data_Success(result.data))
            },
            (error: { data: any; }) => {
                  console.log(`API FAIL: ${apiCall}`);
                  return dispatch(entityActions.getAll_SchoolDesignatedContact_GetSchoolDesignatedContactBySchoolCode_Data_Fault(error.data))
      }); 
}

/**
* apiSchoolsUpdatePOST
* @param apiFactory PostApiSchoolDesignatedContactUpdateApiFactory
* @param body SchoolDesignatedContactRequest
* @param history any  (optional) 
* @param target string (optional)
*/
export const fetchUpdate_SchoolDesignatedContact_Update = <R>(apiFactory: Function, body: SchoolDesignatedContactRequest, history?: any, target?: string, debug?: boolean, mock?: any): ThunkAction<any, R, null, Action<string>> => async (dispatch: (request: any, history?: any, target?: string) => any) => {

      if(!apiFactory){ 
            console.log(`API Factory is undefined or null :  SchoolDesignatedContactApiFactory `);
            return; 
      };

      const apiCall: string =  'apiSchoolDesignatedContactUpdatePost';    
      const entityApi =   apiFactory(ApiManager.getInstance().getConfiguration()); 
      console.log(`API: ${apiCall}`); 

      let payload = body; 
      if(debug){console.log(`PAYLOAD: ${JSON.stringify(payload, undefined, '\t')}`)};

      dispatch(entityActions.update_SchoolDesignatedContact_Update_Data())

      // Mock implementation to be tested 
      if(mock){
            console.log(`MOCK API SUCCESS: ${apiCall}`);       
            return await dispatch(entityActions.update_SchoolDesignatedContact_Update_Data_Success(mock))
      }

      return await entityApi.apiSchoolDesignatedContactUpdatePost("1.0.0", payload).then((response: any) => {        
            console.log(`API SUCCESS: ${apiCall}`);      
            const result = response; 
            return dispatch(entityActions.update_SchoolDesignatedContact_Update_Data_Success(result.data))
            },
            (error: { data: any; }) => {
                  console.log(`API FAIL: ${apiCall}`);
                  return dispatch(entityActions.update_SchoolDesignatedContact_Update_Data_Fault(error.data))
      }); 
}

/**
* apiSchoolsCreatePOST
* @param apiFactory PostApiSchoolInformationCreateApiFactory
* @param body SchoolInformationRequest
* @param history any  (optional) 
* @param target string (optional)
*/
export const fetchCreate_SchoolInformation_Create = <R>(apiFactory: Function, body: SchoolInformationRequest, history?: any, target?: string, debug?: boolean, mock?: any): ThunkAction<any, R, null, Action<string>> => async (dispatch: (request: any, history?: any, target?: string) => any) => {

      if(!apiFactory){ 
            console.log(`API Factory is undefined or null :  SchoolInformationApiFactory `);
            return; 
      };

      const apiCall: string =  'apiSchoolInformationCreatePost';    
      const entityApi =   apiFactory(ApiManager.getInstance().getConfiguration()); 
      console.log(`API: ${apiCall}`); 

      let payload = body; 
      if(debug){console.log(`PAYLOAD: ${JSON.stringify(payload, undefined, '\t')}`)};

      dispatch(entityActions.create_SchoolInformation_Create_Data())

      // Mock implementation to be tested 
      if(mock){
            console.log(`MOCK API SUCCESS: ${apiCall}`);       
            return await dispatch(entityActions.create_SchoolInformation_Create_Data_Success(mock))
      }

      return await entityApi.apiSchoolInformationCreatePost("1.0.0", payload).then((response: any) => {        
            console.log(`API SUCCESS: ${apiCall}`);      
            const result = response; 
            return dispatch(entityActions.create_SchoolInformation_Create_Data_Success(result.data))
            },
            (error: { data: any; }) => {
                  console.log(`API FAIL: ${apiCall}`);
                  return dispatch(entityActions.create_SchoolInformation_Create_Data_Fault(error.data))
      }); 
}

/**
* apiSchoolsGetAllPOST
* @param apiFactory PostApiSchoolInformationGetSchoolInformationBySchoolCodeApiFactory
* @param body SchoolInformationRequest
* @param history any  (optional) 
* @param target string (optional)
*/
export const fetchGetAll_SchoolInformation_GetSchoolInformationBySchoolCode = <R>(apiFactory: Function, body: SchoolInformationRequest, history?: any, target?: string, debug?: boolean, mock?: any): ThunkAction<any, R, null, Action<string>> => async (dispatch: (request: any, history?: any, target?: string) => any) => {

      if(!apiFactory){ 
            console.log(`API Factory is undefined or null :  SchoolInformationApiFactory `);
            return; 
      };

      const apiCall: string =  'apiSchoolInformationGetAllPost';    
      const entityApi =   apiFactory(ApiManager.getInstance().getConfiguration()); 
      console.log(`API: ${apiCall}`); 

      let payload = body; 
      if(debug){console.log(`PAYLOAD: ${JSON.stringify(payload, undefined, '\t')}`)};

      dispatch(entityActions.getAll_SchoolInformation_GetSchoolInformationBySchoolCode_Data())

      // Mock implementation to be tested 
      if(mock){
            console.log(`MOCK API SUCCESS: ${apiCall}`);       
            return await dispatch(entityActions.getAll_SchoolInformation_GetSchoolInformationBySchoolCode_Data_Success(mock))
      }

      return await entityApi.apiSchoolInformationGetSchoolInformationBySchoolCodePost("1.0.0", payload).then((response: any) => {        
            console.log(`API SUCCESS: ${apiCall}`);      
            const result = response; 
            return dispatch(entityActions.getAll_SchoolInformation_GetSchoolInformationBySchoolCode_Data_Success(result.data))
            },
            (error: { data: any; }) => {
                  console.log(`API FAIL: ${apiCall}`);
                  return dispatch(entityActions.getAll_SchoolInformation_GetSchoolInformationBySchoolCode_Data_Fault(error.data))
      }); 
}

/**
* apiSchoolsUpdatePOST
* @param apiFactory PostApiSchoolInformationUpdateApiFactory
* @param body SchoolInformationRequest
* @param history any  (optional) 
* @param target string (optional)
*/
export const fetchUpdate_SchoolInformation_Update = <R>(apiFactory: Function, body: SchoolInformationRequest, history?: any, target?: string, debug?: boolean, mock?: any): ThunkAction<any, R, null, Action<string>> => async (dispatch: (request: any, history?: any, target?: string) => any) => {

      if(!apiFactory){ 
            console.log(`API Factory is undefined or null :  SchoolInformationApiFactory `);
            return; 
      };

      const apiCall: string =  'apiSchoolInformationUpdatePost';    
      const entityApi =   apiFactory(ApiManager.getInstance().getConfiguration()); 
      console.log(`API: ${apiCall}`); 

      let payload = body; 
      if(debug){console.log(`PAYLOAD: ${JSON.stringify(payload, undefined, '\t')}`)};

      dispatch(entityActions.update_SchoolInformation_Update_Data())

      // Mock implementation to be tested 
      if(mock){
            console.log(`MOCK API SUCCESS: ${apiCall}`);       
            return await dispatch(entityActions.update_SchoolInformation_Update_Data_Success(mock))
      }

      return await entityApi.apiSchoolInformationUpdatePost("1.0.0", payload).then((response: any) => {        
            console.log(`API SUCCESS: ${apiCall}`);      
            const result = response; 
            return dispatch(entityActions.update_SchoolInformation_Update_Data_Success(result.data))
            },
            (error: { data: any; }) => {
                  console.log(`API FAIL: ${apiCall}`);
                  return dispatch(entityActions.update_SchoolInformation_Update_Data_Fault(error.data))
      }); 
}

/**
* { name|upperCamelCase }} entityRequests
*/
export const entityRequests = { 
      fetchGet_School_GetSchoolBySchoolCode,                                
      fetchGet_School_GetSchoolsByUserEmail,                                
      fetchUpdate_School_Update,                                
      fetchGet_SchoolCohort_GetSchoolCohortsBySchoolCode,                                
      fetchCreate_SchoolDesignatedContact_Create,                                
      fetchDelete_SchoolDesignatedContact_Delete,                                
      fetchGetAll_SchoolDesignatedContact_GetSchoolDesignatedContactBySchoolCode,                                
      fetchUpdate_SchoolDesignatedContact_Update,                                
      fetchCreate_SchoolInformation_Create,                                
      fetchGetAll_SchoolInformation_GetSchoolInformationBySchoolCode,                                
      fetchUpdate_SchoolInformation_Update,                                
};    
   